import { IconButton, MenuItem, Menu } from '@mui/material';

export const EditMenu = ({ selectedThread, message, setMediaUrls, anchorEl, setAnchorEl, setOpenedMenuId, isMenuOpen, setEditMode, setIsDeleteNoteModalOpen, handleEdit }) => {
  const openMenu = (e, messageId) => {
    setAnchorEl(e.currentTarget);
    setOpenedMenuId(messageId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenedMenuId(null);
    setMediaUrls([]);
    setEditMode(false);
  };

  return (
    <>
      <IconButton
        onClick={(e) => openMenu(e, message.id)}
        id={`message-button-${message.id}`}
        aria-controls={isMenuOpen ? `message-menu-${message.id}` : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
      >
        <i className="fa-solid fa-ellipsis-vertical" style={message.isMainMessage ? { fontSize: '20px', color: '#101828' } : undefined} />
      </IconButton>
      <Menu
        id={`message-menu-${message.id}`}
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleClose}
        sx={{ '.MuiPaper-root': { background: 'white' } }}
        MenuListProps={{
          'aria-labelledby': `message-button-${message.id}`,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem id={message.id} onClick={() => setIsDeleteNoteModalOpen(true)}>
          Delete
        </MenuItem>
        {selectedThread?.format !== 'SAP' && <MenuItem onClick={handleEdit}>Edit</MenuItem>}
      </Menu>
    </>
  );
};
